import { render } from "./WaypointCreateShipment.vue?vue&type=template&id=4e2db66f&scoped=true"
import script from "./WaypointCreateShipment.vue?vue&type=script&lang=js"
export * from "./WaypointCreateShipment.vue?vue&type=script&lang=js"

import "./WaypointCreateShipment.vue?vue&type=style&index=0&id=4e2db66f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e2db66f"]])

export default __exports__